<template>
  <div :class="cn(actionVariants({ variant, color }), props.class)">
    <Icon :name="iconName" size="xl" class="sticky left-4 right-4 fg-white" />
  </div>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { actionVariants } from "@/SharedComponents/Swipeable";
import { cn } from "@/Utils/cn";

const props = defineProps({
  variant: { type: String, required: false },
  color: { type: String, required: false },
  iconName: { type: String, default: "placeholder" },
  class: { type: null, required: false },
});
</script>
